import { openZenifyPopup } from "@/core/services/zenifyChannel";

export default {
  namespaced: true,

  state: {
    isOpen: false,
    phoneCall: null,
    endPhone: false,
    isPopupOpen: false
  },

  mutations: {
    OPEN(state) {
      state.isOpen = true;
    },

    CLOSE(state) {
      state.isOpen = false;
    },

    SET_PHONE(state, phone) {
      state.phoneCall = phone;
    },

    SET_END_PHONE(state) {
      state.endPhone = false;
    },

    SET_POPUP_OPEN(state, status) {
      state.isPopupOpen = Boolean(status);
    }
  },

  actions: {
    open({ commit }) {
      commit('OPEN');
      openZenifyPopup();
    },

    openWithPhone({ commit }, phone) {
      commit('SET_PHONE', phone);
      commit('OPEN');
      openZenifyPopup(phone);
    },

    setEndPhone({ commit }) {
      commit('SET_END_PHONE');
    },

    close({ commit }) {
      commit('CLOSE');
    },

    setPopupOpen({ commit }, status) {
      commit('SET_POPUP_OPEN', status);
    }
  }
};

